import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { Wrapper, P, Button } from '@farewill/ui'
import { COLOR, GTR } from '@farewill/ui/tokens'

import SimpleList from 'components/styled/simple-list'
import { showModal } from 'state/actions'
import { MergeWarningData } from './config'
import { MergeContactsModal } from './merge-contacts-modal'

const StyledP = styled(P)`
  color: ${COLOR.STATE.ERROR};
`

const StyledSimpleList = styled(SimpleList)`
  color: ${COLOR.STATE.ERROR};
  padding-bottom: ${GTR.XS};
`

export const MergeWarningBase = ({
  mergeWarningData,
  thisContactName,
  mergeContact,
}: {
  mergeWarningData: MergeWarningData | null
  thisContactName: string
  mergeContact: () => Promise<void>
}) => {
  const dispatch = useDispatch()

  /** We actually would not expect to not be able to parse the mergeWarning -
   * show a fallback message in this case */
  if (!mergeWarningData)
    return (
      <Wrapper padding={[GTR.S, 0]}>
        <StyledP>
          This email address cannot be saved, please enter a different one.
        </StyledP>
      </Wrapper>
    )

  const { contactId, name, email, hasPriority } = mergeWarningData

  return (
    <Wrapper padding={[GTR.S, 0]}>
      <StyledP>
        <Link
          to={`/contacts/${contactId}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {name}
        </Link>{' '}
        is already using {email}. <br />
        <strong>Email addresses cannot be shared.</strong>
      </StyledP>
      <StyledP>Either:</StyledP>
      <StyledSimpleList bullets>
        <li>enter a different email address </li>
        <li>
          leave the email field blank if they do not have another email address
        </li>
        <li>merge the contacts if you are sure this is the same person</li>
      </StyledSimpleList>
      <Button.Danger
        onClick={() => {
          dispatch(
            showModal({
              component: MergeContactsModal,
              headingText: 'Confirm merge',
              config: {
                thisContact: {
                  name: thisContactName,
                },
                otherContact: { contactId, name, email, hasPriority },
                mergeContact,
              },
            })
          )
        }}
      >
        <strong>Merge contacts</strong>
      </Button.Danger>
    </Wrapper>
  )
}
